import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const faqKeys = [
  { q: 'home_faq.q1', a: 'home_faq.a1' },
  { q: 'home_faq.q2', a: 'home_faq.a2' },
  { q: 'home_faq.q3', a: 'home_faq.a3' },
  { q: 'home_faq.q4', a: 'home_faq.a4' },
  { q: 'home_faq.q5', a: 'home_faq.a5' },
  { q: 'home_faq.q6', a: 'home_faq.a6' },
];

export default function FaqSection() {
  const { t } = useTranslation();

  return (
    <section id="faq" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3">
            {t('home_faq.badge')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900 mb-4">
            {t('home_faq.title')}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            {t('home_faq.subtitle')}
          </p>
        </div>

        <div className="space-y-4">
          {faqKeys.map((item) => (
            <details
              key={item.q}
              className="group bg-white border border-background-200/70 rounded-2xl overflow-hidden"
            >
              <summary className="flex items-center justify-between px-6 py-5 cursor-pointer select-none">
                <span className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-4">
                  {t(item.q)}
                </span>
                <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-background-100 group-open:bg-primary-100 transition-colors duration-200">
                  <i className="ri-add-line text-foreground-600 text-sm group-open:hidden"></i>
                  <i className="ri-subtract-line text-primary-600 text-sm hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-6 pb-5 text-foreground-600 text-sm md:text-base leading-relaxed">
                <p>{t(item.a)}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/allchinabuy-spreadsheet-guide"
            className="inline-flex items-center text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            Read the complete guide for more detailed answers
            <i className="ri-arrow-right-line ml-1.5"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}